export default __webpack_public_path__ + "media/images/react_icons/cleaning-1fa1daba19161f923e1e7464934f2cfb.svg";